import process from "shelljs";

export function getConfig() {
  return {
    hideIfNoPermission: process.env.HIDE_IF_NO_PERMISSION,
  };
}



// WEBPACK FOOTER //
// ./src/utils/config.js